import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'urlHttps'
})
export class UrlHttpsPipe implements PipeTransform {
  
  constructor() { }
  
  transform(value) {
    if (value && !/(http(s?)):\/\//i.test(value)) {
      return 'https://' + value;
    }
    return value;
  }
}